import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';
import {TabBar, Tab} from 'rmwc';

import * as styles from '../../../styles';
import {setSelectedItems} from '../../tree/actions';
import PaginatedContainer from '../../../paginator/paginated_container';
import filtersSelectorGenerator from '../../students/filters';
import { request } from '../../../containers/actions';
import { host_v2 } from '../../../utilities/requests';

//@Radium
export default class GeneralReport extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static tabToType(tab) {
        switch (tab) {
        case 0:
            return 'student';
        case 1:
            return 'school';
        case 2:
            return 'city';
        case 3:
            return 'region';
        case 4:
            return 'global';
        default:
            return null;
        }
    }

    
    state = {currentTab: 0}

    style = {items: {itemsList: {width: 'auto', overflowX: 'auto'}}}

    listFieldsSelector = createSelector(
        [
            (_, state) => state.currentTab,
            context => context.user.id,
        ], 
        currentTab => [
            ...this.context.user.hasPerm('examination.reports')
                ? [{field: 'id', label: window.gettext('ID')}]
                : [],
            {
                field: 
                item =>item?.values?.rank?.category?.all?.global.persian() ?? "-",
                label: window.gettext('Rank'),
                sort: '.rank.category.all.global',
            },
            {
                field: item => GeneralReport.tabToType(currentTab) === 'student' ? `${item?.firstname} ${item?.lastname}` : item.name,
                label: window.gettext('Name'),
                sort: GeneralReport.tabToType(currentTab) === 'student' ? 'firstname' : 'name',
            },

            {
                field: item => (this.context.user.hasPerm('admin') || this.context.user.hasPerm('examination.admin') || this.context.user.hasPerm('client.special'))?
                <span> {item?.schoolName} </span>
                : null,
                label: "مدرسه",
            }, 
            {
                field: item => GeneralReport.tabToType(currentTab) === 'student' ? `${item?.username.persian()}` : '',
                label:GeneralReport.tabToType(currentTab) === 'student' ? window.gettext('username') : '',
                sort: GeneralReport.tabToType(currentTab) === 'student' ? 'username' : 'name',
            },
            {
                field: item => item?.values?.[GeneralReport.tabToType(currentTab) === 'student'
                    ? 'score'
                    : 'average'
                ]?.category?.all?.global?.toPercent().persian(true) ?? "-",
                label: window.gettext('Score'),
                sort: `.${GeneralReport.tabToType(currentTab) === 'student' ? 'score' : 'average'}.category.all.global`,
            },
            {
                field: item => item?.values?.taraz?.category?.all?.global.toFixed().persian() ?? "-",
                label: window.gettext('Taraz'),
                sort: '.rank.category.all.global',
            },
            this.context.user.hasPerm('admin') || this.context.user.hasPerm('examination.admin')? {
                field: item => this.context.user.hasPerm('admin') || this.context.user.hasPerm('examination.admin')?<button
                    style={{
                        ...styles.button,
                        padding: '.25em',
                        boxSizing: 'border-box',
                    }}

                    onClick={event => {
                        event.stopPropagation();
                        var status = window.confirm("درصورت حذف پاسخنامه این دانش آموز، پاسخ نامه او حذف و باید مجدد آزمون دهد. آیا اطمینان دارید؟");
                        if(status)
                        {
                            console.log("remove student "+item.id+" from azmun "+this.props.examination.id);
                            this.context.store.dispatch(request({
                                path: '/delete-users-examination/',
                                body: {students:[item.id],examination_id:this.props.examination.id},
                                method: 'DELETE',
                            },null,0,this.studentRemoved.bind(this),this.studentNotRemoved.bind(this)));
                        }
                    }}
                >حذف پاسخنامه</button>:null,
                label: "عملیات",
            }:{},
            {
                field: item => (this.context.user.hasPerm('admin') || this.context.user.hasPerm('examination.admin'))?
                <span> {(item.exit ?? "-").persian()} /{(item.enter ?? "-").persian()} </span>
                :null,
                label: "ورود / خروج",
            },
            ..._.map(this.props?.examination?.materials, material => ({
                fields: item => [
                    () => item?.values?.[GeneralReport.tabToType(currentTab) === 'student'
                        ? 'score'
                        : 'average'
                    ]?.material?.[material.id]?.global.toPercent().persian(true) ?? "-",
                    () => (item?.values.rank?.material?.[material.id]?.global ?? '-').persian(),
                ],
                label: material.title.persian(),
                sort: `.rank.material.${material.id}.global`,
                labels: [
                    {
                        label: window.gettext('Score'),
                        sort: `.rank.material.${material.id}.global`,
                    },
                    {
                        label: window.gettext('Rank'),
                        sort: `.rank.material.${material.id}.global`,
                    },
                ],
            })),
        ],
    )

    studentRemoved(){
        alert("پاسخنامه حذف شد");
    };
    studentNotRemoved(){
        alert("لطفا مجدد تلاش کنید");
    } 
    excel(){ 
        var token = this.context.store.getState().get('application').get('token'); 
        var auth =token.get('accessToken');
        var url = host_v2 + "/ExportExcel/PublicReport?authToken=" + auth + "&examId="+ this.props.examination.id; 
        window.open(url, '_blank');
    }

    studentsFiltersSelector = filtersSelectorGenerator()
    filtersSelector = createSelector.bind(this)(
        [
            (store, props) => props.examination.id,
            store => this.studentsFiltersSelector(store),
            (_, __, state) => state.currentTab,
        ],
        (examination, studentsFilters, currentTab) => [
            {field: 'examination', value: examination},
            {
                field: 'field',
                value: ['rank', GeneralReport.tabToType(currentTab) === 'student' ? 'score' : 'average', 'taraz'].join(','),
            },
            {field: 'entity_type', value: GeneralReport.tabToType(currentTab)},
            {field: 'group_type', value: 'null'},
            ..._.filter(
                studentsFilters,
                filter => {
                    if (GeneralReport.tabToType(currentTab) === 'region') {
                        return !_.includes(['region', 'city', 'school', 'grade'], filter.field);
                    }
                    else if (GeneralReport.tabToType(currentTab) === 'city') {
                        return !_.includes(['city', 'school', 'grade'], filter.field);
                    }
                    else if (GeneralReport.tabToType(currentTab) === 'school') {
                        return !_.includes(['school', 'grade'], filter.field);
                    }
                    else
                        return true;
                },
            ),
        ],
    )

    sortsSelector = createSelector(
        [
            (_, state) => state.currentTab,
            props => props.examination.id,
        ],
        currentTab => [
            {name: '.rank.category.all.global', label: window.gettext('Rank')},
            ...GeneralReport.tabToType(currentTab) === 'student'
                ? [
                    {name: 'firstname', label: window.gettext('firstname')},
                    {name: 'lastname', label: window.gettext('lastname')},
                ]
                : [
                    {name: 'name', label: window.gettext('Name')},
                ],
            {
                name: `.${GeneralReport.tabToType(currentTab) === 'student' ? 'score' : 'average'}.category.all.global`,
                label: window.gettext('Score'),
            },
            ..._.map(
                this.props.examination.materials,
                material => ({
                    name: `.rank.material.${material.id}.global`,
                    label: material.title,
                }),
            ),
        ],
    )

    async componentDidUpdate(prevProps, prevState) {
        if (!prevState.print && this.state.print) {
            window.scrollTo(0, 0);
            await window.wait();
            window.print();
            this.setState({print: false});
        }
    }

    render() {  
        const userRole = this.context.user.hasPerm('admin') || this.context.user.hasPerm('examination.admin');
        return <div
            style={{
                ..._.pickBy(styles.box, (_, key) => key != 'padding'),
                marginTop: '1em',
                marginBottom: '1em',
                fontSize: `${1 - Math.max(_.size(this.props.examination.materials) - 6, 0) * .04}em`,
                overflowX: 'scroll',
                paddingTop: '.5em',
                paddingLeft: '1em',
                paddingRight: '1em',
            }}>
            <button
                    style={{
                        ...styles.defaultButton,
                        padding: '.5em',
                        boxSizing: 'border-box',
                    }}

                    onClick={()=>this.excel()}
                >خروجی اکسل</button>
            <TabBar
                activeTabIndex={this.state.currentTab}
                onChange={({target: {value}}) => this.setState({currentTab: value})}>
                <Tab>{window.gettext('Student')}</Tab>
                {userRole && <Tab>{window.gettext('School')}</Tab>}
                {userRole && <Tab>{window.gettext('City')}</Tab>}
                {userRole && <Tab>{window.gettext('Region')}</Tab>}
            </TabBar>
            <PaginatedContainer
                pubreport={!userRole}
                sidebar={userRole}
                store={this.props.store.get('paginator')}
                resource='report'
                style={this.style}
                listFields={this.listFieldsSelector(this.context, this.state)}
                tooltip={null}
                title={this.props.title}
                selectable
                events={{onClick: async item => {
                    if (this.state.currentTab === 0)
                        this.context.store.dispatch(push(
                            this.context.store.getState().getIn(
                                ['routing', 'locationBeforeTransitions', 'pathname'],
                            ) + item.id + '/',
                        ));
                    else if (this.state.currentTab === 1) {
                        await this.context.store.dispatch(setSelectedItems(
                            [item.id],
                            'school',
                            this.props.store.getIn(['schoolsTreeFilter', 'elementId']),
                        ));
                        this.setState({
                            currentTab: 0,
                        });
                    }
                    else if (this.state.currentTab === 2) {
                        await this.context.store.dispatch(setSelectedItems(
                            [item.id],
                            'city',
                            this.props.store.getIn(['citiesTreeFilter', 'elementId']),
                        ));
                        this.setState({
                            currentTab: 1,
                        });
                    }
                    else if (this.state.currentTab === 3) {
                        await this.context.store.dispatch(setSelectedItems(
                            [item.id],
                            'region',
                            this.props.store.getIn(['regionsTreeFilter', 'elementId']),
                        ));
                        this.setState({
                            currentTab: 2,
                        });
                    }
                }}}
                filters={this.filtersSelector(this.props.store, this.props, this.state)}
                sorts={this.sortsSelector(this.props, this.state)}
                pageSize={30}
            />
        </div>;
    }
};
